// extracted by mini-css-extract-plugin
export default {"card":"contribute_card__rzmMa","item":"contribute_item__erpcH"};